import { Action } from 'redux';
import { EditPublishedConnection } from '../../app/actions/AppActionTypes';
import { IContentInfo } from '../../ts/models/IContentInfo';

export interface EditPublishedConnectionReduxAction extends Action {
  readonly publishedConnection: IContentInfo;
}

export function editPublishedConnection(publishedConnection: IContentInfo): EditPublishedConnectionReduxAction {
  return {
    type: EditPublishedConnection,
    publishedConnection
  };
}
